// removed by extract-text-webpack-plugin
module.exports = {"container":"_9VVxB3OWwYvqMQmA-d8_s","icon":"_35UcgEoZSW4tWq1or_ybr0"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/utils/empty/Empty.scss
// module id = 1658
// module chunks = 0